import './Home.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

export default function Home() {
  return (
    <section className="home-section" id="home">
      <div className="row center-xs">
        <div className="col-lg-8">
          <div className='home-title'>
            <h1>Victoria Mineva</h1>
            <h2 className="margin-bottom-none">Frontend developer</h2>
            <p>
              <span className='margin-right-8'>
                <FontAwesomeIcon icon={faLocationDot} />
              </span>
              The Netherlands
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}